import map from './components/map';
import mousing from './components/mousing';
import screens from './components/screens';

map();
mousing();
screens();
